export const ImportSlides = props => {
    return false
  }
  
  export default ImportSlides